
import React from 'react'
import './DefaultButton.css'
import { Button } from 'react-bootstrap'
import { Spinner } from 'components'
interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const DefaultButton = ({ children, loading, spinnerVariant, ...otherProps }: IProps) => {
  return (
    <Button variant='primary' {...otherProps}>
      {children}
      {
        loading
          ? <span className='align-text-bottom'>
            &nbsp;
            <Spinner as='span' size='sm' border variant={spinnerVariant} />
          </span>
          : <></>
      }
    </Button>

  )
}

DefaultButton.defaultProps = {
  spinnerVariant: 'light',
}

export default DefaultButton
